module.exports = __webpack_public_path__ + "static/Refinance-81e97f867ea93e9f26007eac2f797ee9.gif";